// extracted by mini-css-extract-plugin
export default {"expandButton":"expandButton___k7wO1","hide":"hide___UdpOh"};